<template>
  <div>
    <!-- SP表示 -->
    <div class="mb-8 lg:hidden">
      <div
        role="tablist"
        class="tabs-boxed tabs bg-inherit p-0"
      >
        <!-- 4週間 -->
        <input
          type="radio"
          name="price_tab"
          role="tab"
          class="te-tab-4weeks tab min-h-[40px] text-[1rem]"
          aria-label="4週間"
          checked
        >
        <div
          role="tabpanel"
          class="tab-content border-0 text-center"
        >
          <div class="flex min-h-[8.1875rem] flex-col justify-center gap-2 bg-co-info-500 p-4 text-white">
            <!-- バッジ -->
            <!-- <img
              class="mx-auto"
              src="~/assets/images/Te/TeCourse/PriceTable/price-badge-campaign.svg"
              alt="キャンペーン"
              width="85"
              height="33"
              loading="lazy"
            > -->
            <h3 class="co-display-10 mb-0 font-bold">
              4週間プラン
            </h3>
            <span class="co-display-13 font-normal">集中して学びたい方向け</span>
          </div>
          <div>
            <!-- 料金 -->
            <div class="te-price-striped border border-[#dee2e6] p-3">
              <b class="font-normal">
                <template v-if="student">社会人</template>
                <span class="co-display-7 px-1 font-bold text-co-info-500">{{ $addComma(social4WeeksPlan.tax_included_price) }}</span>円
                <span class="inline-block lg:hidden">（税込）</span>
                <template v-if="student">
                  <br>
                  学生<span class="co-display-7 px-1 font-bold text-co-info-500">{{ $addComma(student4WeeksPlan.tax_included_price) }}</span>円
                  <span class="inline-block lg:hidden">（税込）</span>
                </template>
              </b>
            </div>
            <!-- 受講期間 -->
            <div class="te-price-striped border border-[#dee2e6] p-3">
              <span class="mb-1 block font-bold lg:hidden">受講期間</span>
              <b class="font-normal">
                <span class="mb-2 block">
                  <span class="mr-2 font-bold">開始</span>{{ beginsMonth }}月{{ beginsDays }}日 ({{ beginsDayOfWeek }})
                </span>
                <span class="block">
                  <span class="mr-2 font-bold">終了</span>{{ dateToMonth(membershipEndsAt4) }}月{{ dateToDay(membershipEndsAt4) }}日 ({{ dateToWeek(membershipEndsAt4) }})
                </span>
              </b>
            </div>
            <!-- メンタリング -->
            <div
              v-if="mentoring"
              class="te-price-striped border border-[#dee2e6] p-3"
            >
              <span class="mb-1 block font-bold lg:hidden">メンタリング</span>
              7回
            </div>
            <!-- チャットサポート -->
            <div
              v-if="chatSupport"
              class="te-price-striped border border-[#dee2e6] p-3"
            >
              <span class="mb-1 block font-bold lg:hidden">チャットサポート</span>
              <slot name="chatSupportTime">
                15〜23時（8時間）
              </slot>
            </div>
            <!-- 学習時間の目安 -->
            <div class="te-price-striped border border-[#dee2e6] p-3">
              <span class="mb-1 block font-bold lg:hidden">学習時間の目安</span>
              <slot name="studyTime4Weeks">
                40〜50時間
              </slot>
              <span class="inline-block lg:hidden">（1週間）</span>
            </div>
            <!-- 実案件サポート -->
            <div
              v-if="matterSupport"
              class="te-price-striped border border-[#dee2e6] p-3"
            >
              <span class="mb-1 block font-bold lg:hidden">
                実案件サポート
                <span class="co-display-14 ml-1">※2</span>
              </span>
              あり
            </div>
          </div>
        </div>

        <!-- 8週間 -->
        <input
          type="radio"
          name="price_tab"
          role="tab"
          class="te-tab-8weeks tab min-h-[40px] text-[1rem]"
          aria-label="8週間"
        >
        <div
          role="tabpanel"
          class="tab-content border-0 text-center"
        >
          <div class="flex min-h-[8.1875rem] flex-col justify-center gap-2 bg-co-success-500 p-4 text-white">
            <!-- バッジ -->
            <!-- <img
              class="mx-auto"
              src="~/assets/images/Te/TeCourse/PriceTable/price-badge-sakiwari.svg"
              alt="先割"
              width="61"
              height="34"
              loading="lazy"
            > -->
            <h3 class="co-display-10 mb-0 font-bold">
              8週間プラン
            </h3>
            <span class="co-display-13 font-normal">じっくり学びたい方向け</span>
          </div>
          <div>
            <!-- 料金 -->
            <div class="te-price-striped border border-[#dee2e6] p-3">
              <b class="font-normal">
                <template v-if="student">社会人</template>
                <span class="co-display-7 px-1 font-bold text-co-success-500">{{ $addComma(social8WeeksPlan.tax_included_price) }}</span>円
                <span class="inline-block lg:hidden">（税込）</span>
                <template v-if="student">
                  <br>
                  学生<span class="co-display-7 px-1 font-bold text-co-success-500">{{ $addComma(student8WeeksPlan.tax_included_price) }}</span>円
                  <span class="inline-block lg:hidden">（税込）</span>
                </template>
              </b>
            </div>
            <!-- 受講期間 -->
            <div class="te-price-striped border border-[#dee2e6] p-3">
              <span class="mb-1 block font-bold lg:hidden">受講期間</span>
              <b class="font-normal">
                <span class="mb-2 block">
                  <span class="mr-2 font-bold">開始</span>{{ beginsMonth }}月{{ beginsDays }}日 ({{ beginsDayOfWeek }})
                </span>
                <span class="block">
                  <span class="mr-2 font-bold">終了</span>{{ dateToMonth(membershipEndsAt8) }}月{{ dateToDay(membershipEndsAt8) }}日 ({{ dateToWeek(membershipEndsAt8) }})
                </span>
              </b>
            </div>
            <!-- メンタリング -->
            <div
              v-if="mentoring"
              class="te-price-striped border border-[#dee2e6] p-3"
            >
              <span class="mb-1 block font-bold lg:hidden">メンタリング</span>
              15回
            </div>
            <!-- チャットサポート -->
            <div
              v-if="chatSupport"
              class="te-price-striped border border-[#dee2e6] p-3"
            >
              <span class="mb-1 block font-bold lg:hidden">チャットサポート</span>
              <slot name="chatSupportTime">
                15〜23時（8時間）
              </slot>
            </div>
            <!-- 学習時間の目安 -->
            <div class="te-price-striped border border-[#dee2e6] p-3">
              <span class="mb-1 block font-bold lg:hidden">学習時間の目安</span>
              <slot name="studyTime8Weeks">
                20〜25時間
              </slot>
              <span class="inline-block lg:hidden">（1週間）</span>
            </div>
            <!-- 実案件サポート -->
            <div
              v-if="matterSupport"
              class="te-price-striped border border-[#dee2e6] p-3"
            >
              <span class="mb-1 block font-bold lg:hidden">
                実案件サポート
                <span class="co-display-14 ml-1">※2</span>
              </span>
              あり
            </div>
          </div>
        </div>

        <!-- 12週間 -->
        <input
          type="radio"
          name="price_tab"
          role="tab"
          class="te-tab-12weeks tab min-h-[40px] text-[1rem]"
          aria-label="12週間"
        >
        <div
          role="tabpanel"
          class="tab-content border-0 text-center"
        >
          <div class="flex min-h-[8.1875rem] flex-col justify-center gap-2 bg-co-warning-500 p-4 text-white">
            <!-- バッジ -->
            <img
              class="mx-auto"
              src="~/assets/images/Te/TeCourse/PriceTable/price-badge-sakiwari.svg"
              alt="先割"
              width="61"
              height="34"
              loading="lazy"
            >
            <h3 class="co-display-10 mb-0 font-bold">
              12週間プラン
            </h3>
            <span class="co-display-13 font-normal">多忙で時間がない方向け</span>
          </div>
          <div>
            <!-- 料金 -->
            <div class="te-price-striped border border-[#dee2e6] p-3">
              <b class="font-normal">
                <template v-if="student">社会人</template>
                <span class="co-display-7 px-1 font-bold text-co-warning-500">{{ $addComma(social12WeeksPlan.tax_included_price) }}</span>円
                <span class="inline-block lg:hidden">（税込）</span>
                <template v-if="student">
                  <br>
                  学生<span class="co-display-7 px-1 font-bold text-co-warning-500">{{ $addComma(student12WeeksPlan.tax_included_price) }}</span>円
                  <span class="inline-block lg:hidden">（税込）</span>
                </template>
              </b>
            </div>
            <!-- 受講期間 -->
            <div class="te-price-striped border border-[#dee2e6] p-3">
              <span class="mb-1 block font-bold lg:hidden">受講期間</span>
              <b class="font-normal">
                <span class="mb-2 block">
                  <span class="mr-2 font-bold">開始</span>{{ beginsMonth }}月{{ beginsDays }}日 ({{ beginsDayOfWeek }})
                </span>
                <span class="block">
                  <span class="mr-2 font-bold">終了</span>{{ dateToMonth(membershipEndsAt12) }}月{{ dateToDay(membershipEndsAt12) }}日 ({{ dateToWeek(membershipEndsAt12) }})
                </span>
              </b>
            </div>
            <!-- メンタリング -->
            <div
              v-if="mentoring"
              class="te-price-striped border border-[#dee2e6] p-3"
            >
              <span class="mb-1 block font-bold lg:hidden">メンタリング</span>
              23回
            </div>
            <!-- チャットサポート -->
            <div
              v-if="chatSupport"
              class="te-price-striped border border-[#dee2e6] p-3"
            >
              <span class="mb-1 block font-bold lg:hidden">チャットサポート</span>
              <slot name="chatSupportTime">
                15〜23時（8時間）
              </slot>
            </div>
            <!-- 学習時間の目安 -->
            <div class="te-price-striped border border-[#dee2e6] p-3">
              <span class="mb-1 block font-bold lg:hidden">学習時間の目安</span>
              <slot name="studyTime12Weeks">
                14〜18時間
              </slot>
              <span class="inline-block lg:hidden">（1週間）</span>
            </div>
            <!-- 実案件サポート -->
            <div
              v-if="matterSupport"
              class="te-price-striped border border-[#dee2e6] p-3"
            >
              <span class="mb-1 block font-bold lg:hidden">
                実案件サポート
                <span class="co-display-14 ml-1">※2</span>
              </span>
              あり
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- PC表示 -->
    <div class="co-container-sm hidden lg:block">
      <table class="table mb-[3.25rem] text-center">
        <thead>
          <tr class="h-[6.25rem]">
            <th class="w-1/5 px-3" />
            <!-- 4週間 -->
            <th class="relative border border-[#dee2e6] bg-co-info-500 px-3 py-0 text-white">
              <!-- バッジ -->
              <!-- <img
                class="absolute -top-[3%] left-1/2 -translate-x-1/2 -translate-y-1/2"
                src="~/assets/images/Te/TeCourse/PriceTable/price-badge-campaign.svg"
                alt="キャンペーン"
                width="85"
                height="33"
                loading="lazy"
              > -->
              <h3 class="co-display-10 mb-0 font-bold">
                4週間プラン
              </h3>
              <span class="co-display-13 font-normal">集中して学びたい方向け</span>
            </th>
            <!-- 8週間 -->
            <th class="relative border border-[#dee2e6] bg-co-success-500 px-3 py-0 text-white">
              <!-- バッジ -->
              <!-- <img
                class="absolute -top-[3%] left-1/2 -translate-x-1/2 -translate-y-1/2"
                src="~/assets/images/Te/TeCourse/PriceTable/price-badge-sakiwari.svg"
                alt="先割"
                width="61"
                height="34"
                loading="lazy"
              > -->
              <h3 class="co-display-10 mb-0 font-bold">
                8週間プラン
              </h3>
              <span class="co-display-13 font-normal">じっくり学びたい方向け</span>
            </th>
            <!-- 12週間 -->
            <th class="relative border border-[#dee2e6] bg-co-warning-500 px-3 py-0 text-white">
              <!-- バッジ -->
              <img
                class="absolute -top-[3%] left-1/2 -translate-x-1/2 -translate-y-1/2"
                src="~/assets/images/Te/TeCourse/PriceTable/price-badge-sakiwari.svg"
                alt="先割"
                width="61"
                height="34"
                loading="lazy"
              >
              <h3 class="co-display-10 mb-0 font-bold">
                12週間プラン
              </h3>
              <span class="co-display-13 font-normal">多忙で時間がない方向け</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- 料金 -->
          <tr class="h-[6.25rem]">
            <th class="whitespace-nowrap border border-[#dee2e6] px-3">
              料金
              <br class="hidden lg:block">
              （税込）
            </th>
            <!-- 4週間 -->
            <td class="border border-[#dee2e6] px-3">
              <b class="mb-1 block font-normal">
                <template v-if="student">社会人</template>
                <span class="co-display-7  px-1 font-bold text-co-info-500">
                  {{ $addComma(social4WeeksPlan.tax_included_price) }}
                </span>円
              </b>
              <b
                v-if="student"
                class="mb-0 block font-normal"
              >
                学生<span class="co-display-7 px-1  font-bold text-co-info-500">{{ $addComma(student4WeeksPlan.tax_included_price) }}</span>円
              </b>
            </td>
            <!-- 8週間 -->
            <td class="border border-[#dee2e6] px-3">
              <b class="mb-1 block font-normal">
                <template v-if="student">社会人</template>
                <span class="co-display-7 px-1 font-bold text-co-success-500">
                  {{ $addComma(social8WeeksPlan.tax_included_price) }}
                </span>円
              </b>
              <b
                v-if="student"
                class="mb-0 block font-normal"
              >
                学生<span class="co-display-7 px-1  font-bold text-co-success-500">{{ $addComma(student8WeeksPlan.tax_included_price) }}</span>円
              </b>
            </td>
            <!-- 12週間 -->
            <td class="border border-[#dee2e6] px-3">
              <b class="mb-1 block font-normal">
                <template v-if="student">社会人</template>
                <span class="co-display-7 px-1  font-bold text-co-warning-500">
                  {{ $addComma(social12WeeksPlan.tax_included_price) }}
                </span>円
              </b>
              <b
                v-if="student"
                class="mb-0 block font-normal"
              >
                学生<span class="co-display-7 px-1  font-bold text-co-warning-500">{{ $addComma(student12WeeksPlan.tax_included_price) }}</span>円
              </b>
            </td>
          </tr>
          <!-- 受講期間 -->
          <tr class="h-[6.25rem]">
            <th class="border px-3">
              受講期間
            </th>
            <!-- 4週間 -->
            <td class="border px-3">
              <b class="mb-2 block font-normal">
                <span class="mr-2 font-bold">開始</span>{{ beginsMonth }}月{{ beginsDays }}日 ({{ beginsDayOfWeek }})
              </b>
              <b class="block font-normal">
                <span class="mr-2 font-bold">終了</span>{{ dateToMonth(membershipEndsAt4) }}月{{ dateToDay(membershipEndsAt4) }}日 ({{ dateToWeek(membershipEndsAt4) }})
              </b>
            </td>
            <!-- 8週間 -->
            <td class="border px-3">
              <b class="mb-2 block font-normal">
                <span class="mr-2 font-bold">開始</span>{{ beginsMonth }}月{{ beginsDays }}日 ({{ beginsDayOfWeek }})
              </b>
              <b class="block font-normal">
                <span class="mr-2 font-bold">終了</span>{{ dateToMonth(membershipEndsAt8) }}月{{ dateToDay(membershipEndsAt8) }}日 ({{ dateToWeek(membershipEndsAt8) }})
              </b>
            </td>
            <!-- 12週間 -->
            <td class="border px-3">
              <b class="mb-2 block font-normal">
                <span class="mr-2 font-bold">開始</span>{{ beginsMonth }}月{{ beginsDays }}日 ({{ beginsDayOfWeek }})
              </b>
              <b class="block font-normal">
                <span class="mr-2 font-bold">終了</span>{{ dateToMonth(membershipEndsAt12) }}月{{ dateToDay(membershipEndsAt12) }}日 ({{ dateToWeek(membershipEndsAt12) }})
              </b>
            </td>
          </tr>
          <!-- メンタリング -->
          <tr
            v-if="mentoring"
            class="h-[6.25rem]"
          >
            <th class="border px-3">
              メンタリング
            </th>
            <!-- 4週間 -->
            <td class="border px-3">
              7回
            </td>
            <!-- 8週間 -->
            <td class="border px-3">
              15回
            </td>
            <!-- 12週間 -->
            <td class="border px-3">
              23回
            </td>
          </tr>
          <!-- チャットサポート -->
          <tr
            v-if="chatSupport"
            class="h-[6.25rem]"
          >
            <th class="border px-3">
              チャットサポート
            </th>
            <!-- 4週間 -->
            <td class="border px-3">
              <slot name="chatSupportTime">
                15〜23時（8時間）
              </slot>
            </td>
            <!-- 8週間 -->
            <td class="border px-3">
              <slot name="chatSupportTime">
                15〜23時（8時間）
              </slot>
            </td>
            <!-- 12週間 -->
            <td class="border px-3">
              <slot name="chatSupportTime">
                15〜23時（8時間）
              </slot>
            </td>
          </tr>
          <!-- 学習時間の目安 -->
          <tr class="h-[6.25rem]">
            <th class="border px-3">
              学習時間の目安
              <br class="hidden lg:block">
              （1週間）
            </th>
            <!-- 4週間 -->
            <td class="border px-3">
              <slot name="studyTime4Weeks">
                40〜50時間
              </slot>
            </td>
            <!-- 8週間 -->
            <td class="border px-3">
              <slot name="studyTime8Weeks">
                20〜25時間
              </slot>
            </td>
            <!-- 12週間 -->
            <td class="border px-3">
              <slot name="studyTime12Weeks">
                14〜18時間
              </slot>
            </td>
          </tr>
          <!-- 実案件サポート -->
          <tr
            v-if="matterSupport"
            class="h-[6.25rem]"
          >
            <th class="border px-3">
              実案件サポート
              <span class="ml-2 text-[0.875em] font-normal">
                ※2
              </span>
            </th>
            <td
              class="border px-3"
              colspan="3"
            >
              あり
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts">

interface Methods {
  dateToMonth(date: Date | null): number | '-'
  dateToDay(date: Date | null): number | '-'
  dateToWeek(date: Date | null): string
}
interface Computed {
  plans: any
  beginsAt: Date | null
  beginsMonth: number | '-'
  beginsDays: number | '-'
  beginsDayOfWeek: '日' | '月' | '火' | '水' | '木' | '金' | '土' | '-'
  membershipEndsAt4: Date | null
  membershipEndsAt8: Date | null
  membershipEndsAt12: Date | null
  membershipEndsAt16: Date | null
  social4WeeksPlan: object
  social8WeeksPlan: object
  social12WeeksPlan: object
  social16WeeksPlan: object
  student4WeeksPlan: object
  student8WeeksPlan: object
  student12WeeksPlan: object
  student16WeeksPlan: object
}
interface Props {
  course: any
  latestCohort: any
  currentPromotion: any
  chatSupportWithinTwentyFourHours: boolean
  matterSupport: boolean
}
const options = {
  props: {
    course: {
      type: Object,
    },
    latestCohort: {
      type: Object,
    },
    currentPromotion: {
      default: null,
    },
    student: { // 学生料金の表示切り替え
      type: Boolean,
      default: false,
    },
    mentoring: { // メンタリングの表示切り替え
      type: Boolean,
      default: false,
    },
    chatSupport: { // チャットサポートの表示切り替え
      type: Boolean,
      default: false,
    },
    matterSupport: { // 実案件サポートの表示切り替え
      type: Boolean,
      default: false,
    },
  },
  filters: {
    addComma(value: number) {
      return value ? value.toLocaleString() : '-'
    },
  },
  computed: {
    plans() {
      return this.course ? this.course.attributes.plans : null
    },
    beginsAt() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.begins_at)
        : null
    },
    beginsMonth() {
      return this.beginsAt ? this.beginsAt.getMonth() + 1 : '-'
    },
    beginsDays() {
      return this.beginsAt ? this.beginsAt.getDate() : '-'
    },
    beginsDayOfWeek() {
      if (this.beginsAt) {
        const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'][
          this.beginsAt.getDay()
        ]
        return dayOfWeek as '日' | '月' | '火' | '水' | '木' | '金' | '土'
      } else {
        return '-'
      }
    },
    membershipEndsAt4() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.membership_ends_at4)
        : null
    },
    membershipEndsAt8() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.membership_ends_at8)
        : null
    },
    membershipEndsAt12() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.membership_ends_at12)
        : null
    },
    membershipEndsAt16() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.membership_ends_at16)
        : null
    },
    social4WeeksPlan() {
      return this.plans ? this.plans.social_4weeks : { tax_included_price: '-' }
    },
    social8WeeksPlan() {
      return this.plans ? this.plans.social_8weeks : { tax_included_price: '-' }
    },
    social12WeeksPlan() {
      return this.plans
        ? this.plans.social_12weeks
        : { tax_included_price: '-' }
    },
    social16WeeksPlan() {
      return this.plans
        ? this.plans.social_16weeks
        : { tax_included_price: '-' }
    },
    student4WeeksPlan() {
      return this.plans
        ? this.plans.student_4weeks
        : { tax_included_price: '-' }
    },
    student8WeeksPlan() {
      return this.plans
        ? this.plans.student_8weeks
        : { tax_included_price: '-' }
    },
    student12WeeksPlan() {
      return this.plans
        ? this.plans.student_12weeks
        : { tax_included_price: '-' }
    },
    student16WeeksPlan() {
      return this.plans
        ? this.plans.student_16weeks
        : { tax_included_price: '-' }
    },
  },
  methods: {
    dateToMonth(date: Date | null) {
      return date ? date.getMonth() + 1 : '-'
    },
    dateToDay(date: Date | null) {
      return date ? date.getDate() : '-'
    },
    dateToWeek(date: Date | null) {
      if (date) {
        const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'][
          date.getDay()
        ]
        return dayOfWeek as '日' | '月' | '火' | '水' | '木' | '金' | '土'
      } else {
        return '-'
      }
    },
  },
}
export default defineNuxtComponent(options)
</script>

<style scoped>
/* SP表示 */
.tabs {
  grid-template-columns: repeat(auto-fit, minmax(33%, 1fr));
}

/* 選択されたタブのスタイル */
.tabs-boxed :is(input:checked) {
  @apply text-white;
}

.tabs-boxed :is(input:checked.te-tab-4weeks) {
  @apply bg-co-info-500;
}

.tabs-boxed :is(input:checked.te-tab-8weeks) {
  @apply bg-co-success-500;
}

.tabs-boxed :is(input:checked.te-tab-12weeks) {
  @apply bg-co-warning-500;
}


/* 背景色 */
.te-price-striped:nth-of-type(odd),
.table tbody tr:nth-of-type(odd) {
  @apply bg-[#f9f9f9];
}

.te-price-striped:nth-of-type(even),
.table tbody tr:nth-of-type(even) {
  @apply bg-white;
}
</style>
